import { Signal } from '@angular/core';
import { z } from 'zod';
import { InjectionToken } from '@angular/core';
import { ProjectQuery } from '@dat/datiq-nx-repo-utils';
import { FormGroup } from '@angular/forms';
import { Control } from '@dat/iq-controls';
import { IqCssClassnames } from '@dat/iq-style-processor';

export const InfoLabelSchema = z.object({
    label: z.string().default('--'),
    tooltipBody: z.string().default(''),
    tooltipHeader: z.string().default(''),
});

export const InfoSchema = z.object({
    name: InfoLabelSchema,
    environment: InfoLabelSchema,
    team: InfoLabelSchema,
    type: InfoLabelSchema,
    domain: InfoLabelSchema,
    e2eProject: InfoLabelSchema,
    leveragesNonCritical: InfoLabelSchema,
    componetized: InfoLabelSchema,
    stability: InfoLabelSchema,
    abstraction: InfoLabelSchema,
    modularity: InfoLabelSchema,
    testCoverage: InfoLabelSchema,
    uiUxCoverage: InfoLabelSchema,
    e2eCoverage: InfoLabelSchema,
    loaded: z.boolean(),
});

export type Info = z.infer<typeof InfoSchema>;
export type InfoLabel = z.infer<typeof InfoLabelSchema>;

export interface IIqStatusLibraryStateService {
    cardInfo(projectKey: string): Promise<Info>;
    numOfProjects(query: ProjectQuery): Promise<number>;
    updateDepViz(element: HTMLElement, query: ProjectQuery): Promise<void>;
    updateEnvViz(element: HTMLElement, query: ProjectQuery): Promise<void>;
    updateTeamViz(element: HTMLElement, query: ProjectQuery): Promise<void>;
    updateDomainViz(element: HTMLElement, query: ProjectQuery): Promise<void>;
    updateLibraryViz(element: HTMLElement, query: ProjectQuery): Promise<void>;
    queryProjectKeys(query: ProjectQuery): Promise<string[]>;
}

export type TableFormRowInfo = {
    id: string;
    containerClasses: IqCssClassnames;
    controls: Control[];
    fg?: FormGroup;
};
